var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: _vm.top_title,
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
            scrollable: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.updateClientCompany.apply(null, arguments)
                },
              },
            },
            [
              _vm.errors.length != 0
                ? _c(
                    "div",
                    _vm._l(_vm.errors, function (e) {
                      return _c("ul", { key: e }, [
                        _c(
                          "li",
                          [
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v(_vm._s(e)),
                            ]),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("顧客コード")]),
                  _vm._v(" "),
                  _c("b-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.client_company.company_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.client_company, "company_code", $$v)
                      },
                      expression: "client_company.company_code",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("顧客名")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "300px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.client_company.company_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.client_company, "company_name", $$v)
                      },
                      expression: "client_company.company_name",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("顧客名(ひらがな)")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "300px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.client_company.company_name_kana,
                      callback: function ($$v) {
                        _vm.$set(_vm.client_company, "company_name_kana", $$v)
                      },
                      expression: "client_company.company_name_kana",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("郵便番号")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "100px" },
                    attrs: { type: "text", placeholder: "123-4567" },
                    model: {
                      value: _vm.client_company.zip_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.client_company, "zip_code", $$v)
                      },
                      expression: "client_company.zip_code",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticStyle: { width: "110px !important" },
                      on: { click: _vm.searchAddress },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "search" } }),
                      _vm._v("住所検索\n        "),
                    ],
                    1
                  ),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("住所1")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "300px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.client_company.address1,
                      callback: function ($$v) {
                        _vm.$set(_vm.client_company, "address1", $$v)
                      },
                      expression: "client_company.address1",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("住所2")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.client_company.address2,
                      callback: function ($$v) {
                        _vm.$set(_vm.client_company, "address2", $$v)
                      },
                      expression: "client_company.address2",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("住所3")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "150px" },
                    attrs: { type: "text" },
                    model: {
                      value: _vm.client_company.address3,
                      callback: function ($$v) {
                        _vm.$set(_vm.client_company, "address3", $$v)
                      },
                      expression: "client_company.address3",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("label", [_vm._v("担当者")]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { width: "200px" },
                      model: {
                        value: _vm.client_company.user_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.client_company, "user_id", $$v)
                        },
                        expression: "client_company.user_id",
                      },
                    },
                    _vm._l(_vm.sel_user_list, function (option) {
                      return _c(
                        "option",
                        { key: option.id, domProps: { value: option.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(option.text) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticStyle: { "margin-left": "660px" },
                      attrs: {
                        type: "submit",
                        variant: "primary",
                        disabled: _vm.pms_master_client_company < 2,
                      },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 保存\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "danger",
                        disabled: _vm.pms_master_client_company < 2,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.delClientCompany(_vm.client_company_id)
                        },
                      },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 削除\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", [_vm._v("顧客担当者")]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticStyle: { width: "800px" } },
              [
                _c("b-table-filter", {
                  attrs: {
                    maxHeight: _vm.maxHeight,
                    filter_list: _vm.filter_list,
                    filter_val: _vm.filter_val,
                    data_list_field: _vm.data_list_field,
                    data_list: _vm.data_list,
                    filter_enable: false,
                    nav_flg: false,
                    edit_disabled: _vm.pms_master_client_company < 2,
                  },
                  on: {
                    on_edit: _vm.modalShow,
                    on_delete: _vm.delClientPerson,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "-10px 0px 0px 0px" } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.data_list.length) + "件  \n      "
              ),
              _c(
                "b-button",
                {
                  ref: "btnShow",
                  staticClass: "icon_btn_w",
                  attrs: {
                    variant: "info",
                    disabled: _vm.pms_master_client_company < 2,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.modalShow(-1)
                    },
                  },
                },
                [
                  _c("b-icon", {
                    attrs: { icon: "plus", "aria-hidden": "true" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-client-person",
                title: _vm.title,
                "header-bg-variant": "dark",
                "header-text-variant": "light",
                "body-bg-variant": "light",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c("div", { staticClass: "modal_div" }, [
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("担当者名")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.client_person.person_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.client_person, "person_name", $$v)
                        },
                        expression: "client_person.person_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("TEL")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.client_person.tel,
                        callback: function ($$v) {
                          _vm.$set(_vm.client_person, "tel", $$v)
                        },
                        expression: "client_person.tel",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("FAX")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.client_person.fax,
                        callback: function ($$v) {
                          _vm.$set(_vm.client_person, "fax", $$v)
                        },
                        expression: "client_person.fax",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("Mail")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.client_person.mail,
                        callback: function ($$v) {
                          _vm.$set(_vm.client_person, "mail", $$v)
                        },
                        expression: "client_person.mail",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _c(
                    "b-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.hide("modal-client-person")
                        },
                      },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "x" } }),
                      _vm._v("取消\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "danger",
                        disabled: this.client_person.id == null,
                      },
                      on: { click: _vm.delClientPerson },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 削除\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.updateClientPerson },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 保存\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }